/* eslint-disable no-param-reassign */
import axios from 'axios';
import { base } from '../../config/config';

class Result {
  constructor(results, pages, totalRes, query) {
    this.results = results;
    this.pages = pages;
    this.totalRes = totalRes;
    this.query = query;
  }
}

export default {
  state: {
    searchData: {
      movies: [],
      tvShows: [],
      people: [],
      pages: '',
      totalRes: '',
      query: '',
      page: null,
    },
  },
  mutations: {
    setQueryResults(state, payload) {
      payload.results.forEach((element) => {
        if (element.media_type === 'movie') {
          state.searchData.movies.push(element);
        } else if (element.media_type === 'tv') {
          state.searchData.tvShows.push(element);
        } else if (element.media_type === 'person') {
          state.searchData.people.push(element);
        } else {
          console.log('Uups... media_type not found?!');
        }
      });
      state.searchData.pages = payload.pages;
      state.searchData.totalRes = payload.totalRes;
      state.searchData.query = payload.query;
      state.searchData.page += 1;
    },
    resetQueryResults(state) {
      state.searchData.movies = [];
      state.searchData.tvShows = [];
      state.searchData.people = [];
      state.searchData.pages = '';
      state.searchData.totalRes = '';
      state.searchData.query = '';
      state.searchData.page = null;
    },
  },
  actions: {
    async getQueryResults({ commit, state }, { query }) {
      commit('clearError');
      commit('setLoading', true);

      if (query !== '') {
        try {
          const url = `${base.urlPrefix}/search/multi?api_key=${base.key}&${
            base.language
          }&query=${query}&page=${
            state.searchData.page === null ? 1 : state.searchData.page + 1
          }&include_adult=false`;
          const response = await axios.get(url);
          const { data } = response;

          const result = new Result(
            data.results,
            data.total_pages,
            data.total_results,
            query,
          );

          commit('setLoading', false);
          commit('setQueryResults', result);
        } catch (error) {
          commit(
            'setError',
            `Uups! Da is was schief gelaufen: ${error.message}`,
          );
          commit('setLoading', false);
        }
      } else {
        commit('resetQueryResults');
        commit('setLoading', false);
      }
    },
    clearSearchResults({ commit }) {
      commit('resetQueryResults');
      commit('setLoading', false);
    },
  },
  getters: {
    getQueryTotalRes(state) {
      return state.searchData.totalRes;
    },
    getSearchResults(state) {
      return state.searchData;
    },
  },
};
